export default "__VITE_ASSET__CBdc8J5z__"